import { render, staticRenderFns } from "./CommunitySignupStep1.vue?vue&type=template&id=5928b916&scoped=true"
import script from "./CommunitySignupStep1.vue?vue&type=script&lang=js"
export * from "./CommunitySignupStep1.vue?vue&type=script&lang=js"
import style0 from "./CommunitySignupStep1.vue?vue&type=style&index=0&id=5928b916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928b916",
  null
  
)

export default component.exports